import React, { Component, Fragment } from 'react'
import { STEP_TYPES } from '../constants'
import { pathOr } from 'ramda'
import PropTypes from 'prop-types'
import DemoRequestStep from '../component'
import BotPreview from 'components/OnboardingBotPreview'


const STEP_OBJECT = Object.freeze(STEP_TYPES.VALUE_PROP)
class ValuePropStep extends Component {

  static propTypes = {
    index: PropTypes.number.isRequired,
    stepCount: PropTypes.number.isRequired,
    onContinue: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      valueProp: '', //TODO: prefill from clearbit
      previewInputValue: STEP_OBJECT.previewTextDefault,
    }
  }

  handleInputChange = (event) => {
    const { previewTextDefault } = STEP_OBJECT
    const changedValue = pathOr('', ['target', 'value'], event)
    const previewChangedValue = !!changedValue ? changedValue : previewTextDefault
    this.setState({ valueProp: changedValue, previewInputValue: previewChangedValue })
  }

  handleValuePropSave = () => {
    const { actions } = this.props
    const { valueProp } = this.state
    actions.setValueProp(valueProp)
  }

  render() {
    const { productName } = this.props
    const { valueProp, previewInputValue } = this.state
    const botPreview = <BotPreview productName={productName} valueProp={previewInputValue} tipText={STEP_OBJECT.tipText} arrowSource={STEP_OBJECT.arrowSource} />
    return (
      <Fragment>
        <DemoRequestStep stepObject={STEP_OBJECT} botPreview={botPreview} inputValue={valueProp} handleSave={this.handleValuePropSave} handleInputChange={this.handleInputChange} {...this.props} />
      </Fragment>
    )
  }
}

export default ValuePropStep



// WEBPACK FOOTER //
// ./src/layouts/OnboardingPlaybookDemoRequestStep/ValuePropStep/index.js